import React from 'react';

const Loading = () => {
    return (
        <div className='flex justify-center mt-20 mb-24'>
            <button className="btn btn-error text-white font-bold loading block mx-auto">loading</button>
        </div>
    );
};

export default Loading;